import "./modules/common";
import Uri from "urijs";
import VueApp from "~/Scripts/new/vueApp";
import EventSearch from "~/Components/Search/EventSearch.vue";
import EventSearchFilters from "~/Components/Search/EventSearchFilters.vue";
import CalendarComponent from "~/Components/Events/CalendarComponent.vue";

const uri = new Uri( window.document.location.href );
const queryString = uri.search( true );

let queryMonth = null;
let queryDate = null;
let querySubTheme = null;
let queryFilters = [];

if ( queryString ) {
  if ( queryString.month ) {
    const parts = queryString.month.split( "-" );
    const year = Number.parseInt( parts[0], 10 );
    const month = Number.parseInt( parts[1], 10 ) - 1;
    queryMonth = new Date( year, month );
  }

  if ( queryString.date ) {
    const parts = queryString.date.split( "-" );
    const year = Number.parseInt( parts[0], 10 );
    const month = Number.parseInt( parts[1], 10 ) - 1;
    const day = Number.parseInt( parts[2], 10 );
    queryDate = new Date( year, month, day );
  }

  querySubTheme = queryString.subTheme;

  if ( queryString.filters ) {
    queryFilters = queryString.filters.split( "," );
  }
}

new VueApp( {
  name: "EventArea",
  components: {
    EventSearch,
    CalendarComponent,
    EventSearchFilters
  },
  data: () => ( {
    selectedMonth: queryMonth,
    selectedDate: queryDate,
    selectedTypes: queryFilters,
    selectedSubTheme: querySubTheme,
    selectedSort: null
  } ),
  methods: {
    selectDate ( val ) {
      this.selectedDate = val;
    },
    selectMonth ( val ) {
      this.selectedMonth = val;
    },
    selectSort ( val ) {
      this.selectedSort = val;
    },
    selectType ( val ) {
      this.selectedTypes = val;
    },
    selectSubTheme ( val ) {
      this.selectedSubTheme = val;
    }
  }
} );
